<template>
	<v-footer
		:app="$vuetify.breakpoint.smAndUp"
		color="white"
		class="py-0"
		:absolute="!$vuetify.breakpoint.smAndUp"
	>
		<v-spacer/>
		<div class="d-flex flex-wrap justify-space-around align-center flex-grow-1">
			<!-- phone -->
			<a
				v-if="mainBranch.contacts.phone"
				dir="ltr"
				:href="`tel:${mainBranch.contacts.phone}`"
				class="black--text text-decoration-none me-1 my-1"
			>
				<v-icon color="grey darken-3 mr-2">mdi-phone</v-icon>
				{{mainBranch.contacts.phone}}
			</a>
			
			<!-- mobile -->
			<a
				v-if="mainBranch.contacts.mobile"
				dir="ltr"
				:href="`tel:${mainBranch.contacts.mobile}`"
				class="black--text text-decoration-none me-1 my-1"
			>
				<v-icon color="grey darken-3 mr-2">mdi-phone</v-icon>
				{{mainBranch.contacts.mobile}}
			</a>

			<!-- whatsapp -->
			<a
				v-if="mainBranch.contacts.whatsapp"
				dir="ltr"
				:href="`https://wa.me/${mainBranch.contacts.mobile}`"
				target="_blank"
				rel="noopener noreferrer"
				class="black--text text-decoration-none me-1 my-1"
			>
				<v-icon color="grey darken-3 mr-2">mdi-whatsapp</v-icon>
				{{mainBranch.contacts.whatsapp}}
			</a>

			<!-- email -->
			<a
				v-if="mainBranch.contacts.email"
				dir="ltr"
				:href="`mailto:${mainBranch.contacts.mobile}`"
				class="black--text text-decoration-none me-1 my-1"
			>
				<v-icon color="grey darken-3 mr-2">mdi-email</v-icon>
				{{mainBranch.contacts.email}}
			</a>

			<!-- address -->
			<div v-if="mainBranch.contacts.address" dir="ltr">
				<v-icon color="grey darken-3 mr-2">mdi-map-marker-radius</v-icon>
				{{mainBranch.contacts.address}}
			</div>
		</div>
		<v-spacer/>
	</v-footer>
</template>

<script>
import { mapState } from 'vuex';
export default {
	name: 'FooterVue',

	computed: {
		...mapState({
			branches: state => state.contactus.branches
		}),

		mainBranch() {
			return this.branches.find(c => c.isMain) || { contacts: {} }
		}
	},
};
</script>